/*
** $Id$
**
** Copyright 2018 Port25 Solutions, Inc.
** All rights reserved.
*/


import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import ListingPage from './ListingPage';
import PropTypes from 'prop-types';
import { formatBoolean } from '../util/Utils'
var homepage = require('../../package.json').homepage;


export const DEFAULT_QUEUES = '*/*'


/**
 * Queues page of web monitor.
 */
export default class Queues extends Component {
    static propTypes = {
        showError: PropTypes.func.isRequired,
        setRefresh: PropTypes.func.isRequired,
        setRefreshInterval: PropTypes.func.isRequired,

        /**
         * Name of the queue for which the listing is desired. 
         * If not specified, defaults to all queues.
         */
        queue: PropTypes.string
    };


    nameFormatter(queueName) {
        if (queueName.indexOf('*') >= 0) {
            return queueName
        }
        return <Link to={`${homepage}/queueDetail/${queueName}`}>{queueName}</Link>
    }


    render() {
        let columns = {
            'Name': 'name',
            '#Rcpt': 'rcp',
            '#KBytes': 'kb',
            '#Conn': 'conn',
            'Paused': 'paused',
            'Mode': 'mode'
        }

        let defaultName, defaultPmtaOptions
        if (this.props.queue) {
            defaultName = this.props.queue
            defaultPmtaOptions = {
                queue: this.props.queue
            }
        }
        else {
            defaultName = DEFAULT_QUEUES
        }

        let columnFormatter = {
            Name: this.nameFormatter,
            Paused: formatBoolean
        }

        return (
            <ListingPage name='queue'
                         defaultName={defaultName}
                         defaultPmtaOptions={defaultPmtaOptions}
                         urlPath='/queues'
                         items='queues'
                         columns={columns}
                         showError={this.props.showError}
                         showLastError={true}
                         showViewOptions={true}
                         columnFormatter={columnFormatter}
                         setRefresh={this.props.setRefresh}
                         setRefreshInterval={this.props.setRefreshInterval}/>
        );
    }
}
